<template>
  <div class="orgList app-container">
    <div class="global-header-wrap">
      <h3>机构列表</h3>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div slot="header">
        <div class="global-table-header">
          <div class="orgList-header-btn-left">
            <list-search ref="listSearch" @listSearchEvn="listSearchEvn" />
          </div>
          <div class="orgList-header-btn-right">
            <button class="global-button-style" @click="toCreate">
              {{ $t("org.newOrg") }}
            </button>
            <button class="global-button-style">{{ $t("org.sync") }}</button>
            <button class="global-button-style">
              {{ $t("org.exportDevice") }}
            </button>
          </div>
        </div>
      </div>
      <div class="global-body-wrap">
        <appTable
          :tableProps="tableProps"
          :tableData="tableData"
          :selectCtrl="false"
          @tableHandle="tableHandle"
        />
      </div>

      <pagination
        :pageSize="params.limit"
        :total="total"
        @pageNum="getPageNum"
      />
    </el-card>

    <transition name="fade">
      <CreateOrg
        :title="orgTitle"
        v-if="showCreateOrg"
        :orgItem="orgItem"
        @createEvn="createEvn"
      />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CreateOrg from "@/components/createOrg";
import Area from "@/components/area";
import listSearch from "@/components/listSearch";
import appTable from "@/components/appTable";
import pagination from "@/components/pagination";
import listMixin from "@/mixins/list";
import { country } from "@/utils/country";
export default {
  name: "orgList",
  components: {
    CreateOrg,
    listSearch,
    appTable,
    pagination,
    Area
  },
  computed: {
    ...mapGetters(["showCreateOrg"]),
    tableProps() {
      let tableProps = [
        {
          prop: "name",
          label: this.$t("org.orgName")
        },
        {
          prop: "address",
          label: this.$t("org.area")
        },
        {
          prop: "fid",
          label: "FID"
        },
        {
          prop: "devices",
          label: this.$t("org.deviceCount")
        },
        {
          prop: "tag",
          label: this.$t("org.tag")
        },
        {
          prop: "handle",
          label: this.$t("commonMsg.handle"),
          width: 200,
          btn: [
            this.$t("commonMsg.edit"),
            this.$t("commonMsg.checkDetails"),
            this.$t("commonMsg.del")
          ]
        }
      ];
      return tableProps;
    }
  },
  mixins: [listMixin],
  data() {
    return {
      params: {
        limit: 20,
        offset: 0
        // sortBy:'id'
      },
      orgTitle: "",
      areaArr: [],
      tableData: [],
      total: 0,
      orgItem: {}
    };
  },
  methods: {
    getList() {
      this.$http.getOrgList(this.params).then(res => {
        this.tableData = res.data.rows;
        this.total = res.data.count;
      });
    },

    createEvn(data) {
      let { form, type } = data;
      let area = {
        province: form.areaArr[0],
        city: form.areaArr[1],
        area: form.areaArr[2]
      };
      let obj = form;
      delete obj.areaArr;
      obj = Object.assign(obj, area);

      if (type === "create") {
        this.$http.createOrg(obj).then(res => {
          this.getList();
        });
      } else {
        this.$http.editOrg(obj.id, obj).then(res => {
          this.getList();
        });
      }
    },

    del(data) {
      this.$http.delOrg(data.row.id).then(res => {
        this.getList();
        this.elMsg(this.$t("alertMsg.delSuccess"), "success");
        // this.tableData.splice(data.$index, 1)
      });
    },

    toCreate() {
      this.orgItem = {};
      this.orgTitle = this.$t("org.newOrg");
      this.$store.commit("windowHandle", "showCreateOrg");
    },

    edit(data) {
      this.orgTitle = this.$t("org.updateOrg");
      let { row } = data;
      this.orgItem.id = row.id;
      this.orgItem.name = row.name;
      this.orgItem.address = row.address;
      this.orgItem.tagId = row.tagId;
      this.orgItem.fid = row.fid;
      this.orgItem.country = row.country;
      this.orgItem.lang = row.lang;
      this.orgItem.areaArr = [row.province, row.city, row.area];
      this.$store.commit("windowHandle", "showCreateOrg");
    },

    toDetails(data) {
      this.$router.push({
        name: "orgListDetails",
        query: { id: data.row.id, name: data.row.name, tab: "usersInfo" }
      });
    },

    clearArea() {
      if (!this.areaArr.length) return;
      delete this.params.province;
      delete this.params.city;
      delete this.params.area;
      this.areaArr = [];
      this.$refs.areaBox.clearValue();
    },

    areaHandle(areaArr) {
      [this.params.province, this.params.city, this.params.area] = areaArr;
      if (this.params.text) delete this.params.text;
      this.$refs.listSearch.clearValue();
      this.getList();
      this.areaArr = areaArr;
    }
  }
};
</script>

<style lang="scss" scoped>
.orgList {
  .orgList-header {
    padding: 10px 20px;
  }
  .orgList-header-area {
    display: flex;
    align-items: center;
    > span {
      margin-top: 2px;
    }
  }
}
</style>
